/**
 * useUsers Hook
 *
 * React Query hook for fetching the list of users for a tenant.
 */

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { userService } from '../../../api/user.service';
import type { UserSanitized, UserListQuery } from '../../../types/user.types';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for fetching users list
 */
export const useUsers = (
  tenantId: string,
  query?: UserListQuery
): UseQueryResult<UserSanitized[], Error> => {
  return useQuery<UserSanitized[], Error>({
    queryKey: ['users', tenantId, query],
    queryFn: async () => {
      console.log('[useUsers] Fetching users for tenant:', tenantId);
      return await userService.listUsers(tenantId, query);
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      console.error('[useUsers] Failed to fetch users:', getErrorMessage(error));
    },
  });
};
